'use client';

import type { PostType } from '@prisma/client';
import { Suspense } from 'react';
import type { RouterOutputs } from '@/server/callers/client';
import HeroSection from './components/hero-section';
import PostCarousel from './components/post-carousel';
import PostsList from './components/post-list';

export default function PostTypePage({
  postType,
  initialData,
}: {
  postType?: PostType;
  initialData: RouterOutputs['posts']['infinity'];
}) {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <HeroSection postType={postType} />

      {/* Featured Posts Marquee */}
      <section data-aos="fade-up" className="py-8">
        <div className="max-w-7xl mx-auto mb-8">
          <h2 className="text-3xl font-medium mb-6 px-4">
            Featured {postType || 'Posts'}
          </h2>
          <Suspense
            fallback={
              <div className="h-64 w-full bg-gray-100 animate-pulse rounded-lg px-4" />
            }
          >
            <PostCarousel postType={postType} />
          </Suspense>
        </div>
      </section>

      {/* All Posts with Infinite Scroll */}
      <section
        data-aos="fade-up"
        data-aos-duration="1000"
        className="py-8 px-4 bg-gray-50"
      >
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-medium mb-6">Latest {postType || 'Posts'}</h2>
          <Suspense
            fallback={
              <div className="h-64 w-full bg-gray-100 animate-pulse rounded-lg" />
            }
          >
            <PostsList postType={postType} initialData={initialData} />
          </Suspense>
        </div>
      </section>
    </div>
  );
}
